<section class="title-container">
  <h2 class="title">{{'Reports.OutstandingAmount.Title' | translate}}</h2>
  <hr class="separation-line" />
</section>

<section class="filters-container">
  <fieldset class="customers">
    <label class="label"> {{'Reports.Filters.CustomerNumbers' | translate}} </label>
    <custom-multi-select [options]="customers$ | async" [clearEnabled]="true" [searchEnabled]="true"
      [(selectedKeys)]="selectedCustomers" [disabled]="userAssignedCustomersCount <= 1">
    </custom-multi-select>
  </fieldset>

  <fieldset>
    <label class="label required">
      {{'Reports.OutstandingAmount.Period' | translate}}
    </label>
    <p-datepicker view="month" dateFormat="mm/yy" [(ngModel)]="period"></p-datepicker>
  </fieldset>

  <fieldset>
    <label class="label">
      {{'Reports.OutstandingAmount.CustomerRef' | translate}} 1
    </label>
    <input type="text" class="text-input" [(ngModel)]="filter.customerRef1">
  </fieldset>

  <fieldset>
    <label class="label">
      {{'Reports.OutstandingAmount.CustomerRef' | translate}} 2
    </label>
    <input type="text" class="text-input" [(ngModel)]="filter.customerRef2">
  </fieldset>
  <fieldset>
    <label class="label">
      {{'Reports.OutstandingAmount.CustomerRef' | translate}} 3
    </label>
    <input type="text" class="text-input" [(ngModel)]="filter.customerRef3">
  </fieldset>
  <fieldset>
    <button type="button" class="button-basic" (click)="onGenerateReport($event)">
      {{'Reports.OutstandingAmount.GenerateReport' | translate}}
    </button>
    <div class="excel">
      <button type="button" class="button-basic-reverse" (click)="onDownloadExcel()">
        {{'Reports.OutstandingAmount.Download' | translate}}
      </button>
      <mat-progress-spinner mode="indeterminate" [diameter]="30" *ngIf="isDownloading"></mat-progress-spinner>
    </div>
  </fieldset>
</section>

<section *ngIf="totalNumberOfItems > 0" class="results-container">
  <p-table size="small" [paginator]="true" [lazy]="true"
    [value]="debtorCasePeriodsBalance ?? [[]]" (onLazyLoad)="onPageChange($event)" [(rows)]="numberOfItemsPerPage"
    [rowsPerPageOptions]="[5,10,15,20]" [totalRecords]="totalNumberOfItems" selectionMode="single"
    [loading]="isLoading" [scrollable]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>
          {{'Reports.OutstandingAmount.DebtorName' | translate }}
        </th>
        <th></th>
        <th *ngFor="let col of columns">
          {{ col.translationTag | translate }}
        </th>
        <th *ngFor="let periodCol of periodColumns">
          {{'Reports.OutstandingAmount.Period' | translate}} {{periodCol.month}} - {{periodCol.year}}
        </th>
        <th>
          {{'Reports.OutstandingAmount.PreviousPeriods' | translate}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr *ngFor="let case of item.casesBalance; let i = index" (click)="openCaseInNewTab(case)" class="clickable">
        <td>
          <ng-container *ngIf="i == 0">
            {{ case.debtorName }}
          </ng-container>
        </td>
        <td></td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'date'">
              {{ case[col.field] | date: dateFormat }}
            </ng-container>
            <ng-container *ngSwitchCase="'decimal'">
              {{ case[col.field] | number : numberFormat.style: numberFormat.culture }}
            </ng-container>
            <ng-container *ngSwitchDefault>{{case[col.field]}}</ng-container>
          </ng-container>
        </td>
        <td *ngFor="let period of case.periodsBalance">
          {{ period.balanceAmount | number : numberFormat.style: numberFormat.culture }}
        </td>
        <td>
          {{ case.previousPeriodsBalance | number : numberFormat.style: numberFormat.culture }}
        </td>
      </tr>
      <tr class="case-totals-row">
        <td></td>
        <td>{{'Reports.OutstandingAmount.Total' | translate }}</td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'decimal'">
              {{ item.periodsBalanceTotals[col.field] | number : numberFormat.style: numberFormat.culture }}
            </ng-container>
            <ng-container *ngSwitchDefault>{{item.periodsBalanceTotals[col.field]}}</ng-container>
          </ng-container>
        </td>
        <td *ngFor="let period of item.periodsBalanceTotals.periodsBalance">
          {{ period.balanceAmount | number : numberFormat.style: numberFormat.culture}}
        </td>
        <td>
          {{ item.periodsBalanceTotals.previousPeriodsBalance | number : numberFormat.style: numberFormat.culture }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
        <tr class="totals-row">
          <td>{{'Reports.OutstandingAmount.Total' | translate }}</td>
          <td></td>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.type">
              <ng-container *ngSwitchCase="'decimal'">
                {{ periodsBalanceTotals[col.field] | number : numberFormat.style: numberFormat.culture }}
              </ng-container>
              <ng-container *ngSwitchDefault>{{periodsBalanceTotals[col.field]}}</ng-container>
            </ng-container>
          </td>
          <td *ngFor="let period of periodsBalanceTotals.periodsBalance">
            {{ period.balanceAmount | number : numberFormat.style: numberFormat.culture}}
          </td>
          <td>
            {{ periodsBalanceTotals.previousPeriodsBalance | number : numberFormat.style: numberFormat.culture }}
          </td>
        </tr>
    </ng-template>
  </p-table>
</section>
